import { Control, useController } from 'react-hook-form'
import React, { useRef } from 'react'

const formatNumberWithCommas = (number: string) => {
  if (!number) return ''
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const removeCommas = (value: string) => {
  return value.replace(/,/g, '')
}

export const NumberInput = ({
  name,
  control,
  rules,
  defaultValue,
  trackField,
}: {
  name: string
  control: Control
  rules: Record<string, any>
  defaultValue?: string
  trackField: (name: string, value: string) => void
}) => {
  const {
    field: { onChange, onBlur, value },
  } = useController({
    name,
    control,
    rules: {
      pattern: { value: /^[0-9]*$/, message: 'please enter a valid number' },
      ...rules,
    },
    defaultValue: defaultValue ?? '',
  })

  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value
    const caretPosition = e.target.selectionStart

    const rawValue = removeCommas(inputValue)
    onChange(rawValue)

    if (inputRef.current) {
      const formattedValue = formatNumberWithCommas(rawValue)
      const newCaretPosition = caretPosition! + (formattedValue.length - inputValue.length)

      setTimeout(() => {
        inputRef.current?.setSelectionRange(newCaretPosition, newCaretPosition)
      }, 0)
    }
  }

  return (
    <input
      name={name}
      type='text'
      placeholder='£'
      ref={inputRef}
      value={formatNumberWithCommas(value)}
      onChange={handleChange}
      onBlur={() => {
        trackField(name, value)
        onBlur()
      }}
    />
  )
}
